<script>
  import * as restfulService from '../../../../services/restfulService'
  import * as notifyService from '../../../../services/notifyService'
  import DataService from '../../../../services/dataService'
  import bus from '@utils/bus'
  import helperMixin from '../../../../../mixins/helper'
  import {cloneDeep} from 'lodash'
  import {mapActions} from 'vuex'

  export default {
    mixins: [helperMixin],
    props: ['registration'],
    data () {
      return {
        isLoadingData: true,
        isSubmitted: false,
        dependencies: {
          evaluation_types: []
        },
        modalities: []
      }
    },
    mounted () {
      if (!this.registration) {
        this.$swal({
          title: 'Atenção',
          text: 'Você não pode acessar essa página diretamente',
          type: 'warning'
        })
        this.$router.push({name: 'registration.index'})
      } else {
        this.getDependencies()
        this.loadModalities(this.registration.eventData.data.modalities)
        this.isLoadingData = false
        bus.$emit('hide-loader')
      }
    },
    methods: {
      ...mapActions(['login']),
      /**
       * Buscas as dependencias na API
       * @returns {Promise<any>}
       */
      getDependencies () {
        return new Promise(resolve => {
          DataService.get([
            {domain: 'evaluation_type'}
          ]).then((result) => {
            this.dependencies = {...this.dependencies, ...result}
            resolve()
          })
        })
      },
      /**
       * Retorna a etapa na inscrição
       * Passa os dados preenchidos via props para serem recuperados na etapa
       */
      onPrevious () {
        let data = cloneDeep(this.registration)
        this.$router.push({name: 'registration.store.event', params: {registration: data}})
      },
      /**
       * Função para carregar o nome e nome do evento das modalidades selecionadas
       */
      loadModalities (modalities) {
        modalities = modalities.filter(item => item > 0)
        let data = {'id': {'in': modalities}}
        restfulService.search('event_modality', null, data, null, ['modality', 'event'])
          .then((response) => {
            this.modalities = response.data
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      /**
       * Função para mostrar os tipos de avaliação que o avaliador selecionou
       */
      showEvaluations (modalityId) {
        let modality = this.registration.eventData.data.modalitiesWithEvaluationType.find(item => item.id === modalityId)
        return this.dependencies.evaluation_types.filter(item => modality.evaluation_types.includes(item.id)).map(item => item.name).join(', ')
      },
      /**
       * Finaliza a inscrição enviando os dados para a API
       * Caso o usuário não esteja logado, é retorndo os dados do usuário e token de acesso como resposta da requisição,
       * assim o usuário é logado no sistema e redirecionado para visualizar a inscrição e o boleto
       */
      onSaveRegistration () {
        bus.$emit('show-loader')
        let data = cloneDeep({...this.registration.personalData.data, ...this.registration.physicalData.data, ...this.registration.eventData.data})
        data.cep = this.onlyNumbers(data.cep)
        data.cpf = this.onlyNumbers(data.cpf)
        data.ec_cep = this.onlyNumbers(data.ec_cep)
        data.ec_cpf_cnpj = this.onlyNumbers(data.ec_cpf_cnpj)
        data.modalities.splice(0)
        this.registration.eventData.data.modalities.forEach(item => {
          if (item > 0) {
            let modality = this.registration.eventData.data.modalitiesWithEvaluationType.find(modalityItem => modalityItem.id === item)
            data.modalities.push({
              id: item,
              evaluation_types: modality.key === 'avaliador' ? modality.evaluation_types : []
            })
          }
        })
        data.knowledge_areas = this.registration.eventData.data.knowledge_areas.map(item => item.id)
        delete data.modalitiesWithEvaluationType
        restfulService.post('registration', null, null, data)
          .then((response) => {
            notifyService.success({hideLoader: true, message: 'Parabéns, sua inscrição foi registrada com sucesso.'})
            let routerRoute = {name: 'registration.show', params: {id: response.registration_id}}
            if (data.minicurso) {
              routerRoute.params.tab = 'short-courses'
            }
            if (!this.isLogged) {
              this.login(response).then(() => {
                this.$router.push(routerRoute)
              })
            } else {
              this.$router.push(routerRoute)
            }
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">
        <div class="forms form-registration confirm-registration">
            <div class="buttons-center">
                <el-button type="default"
                           size="large"
                           @click="onPrevious()">
                    <i class="fa fa-arrow-left"></i>
                    <span>Voltar</span>
                </el-button>
            </div>
            <h2>Confirmação</h2>
            <h3>Confirme os dados da sua inscrição antes de prosseguir.</h3>
            <table class="table-confirmation">
                <tbody>
                <tr>
                    <td width="50%">
                        <strong>Nome:</strong> {{registration.personalData.data.nome}}
                    </td>
                    <td width="50%">
                        <strong>CPF:</strong> {{registration.physicalData.data.cpf}}
                    </td>
                </tr>
                <tr>
                    <td width="50%">
                        <strong>Data Nascimento:</strong> {{registration.physicalData.data.dt_nascimento | dateEnToBr}}
                    </td>
                    <td width="50%">
                        <strong>RG:</strong> {{registration.physicalData.data.rg_numero}}
                    </td>
                </tr>
                <tr>
                    <td width="50%">
                        <strong>Celular:</strong> {{registration.physicalData.data.fone_celular}}
                    </td>
                    <td width="50%">
                        <strong>Email:</strong> {{registration.personalData.data.email}}
                    </td>
                </tr>
                <tr>
                    <td width="50%">
                        <strong>Escolaridade:</strong> {{registration.eventData.data.literacy.name}}
                    </td>
                    <td width="50%">
                        <strong>Instituição:</strong> {{registration.eventData.data.institution.name}}
                    </td>
                </tr>
                <tr>
                    <td width="50%">
                        <strong>Valor da Inscrição:</strong> R$ {{registration.eventData.data.amount | currencyEnToBr}}
                    </td>
                    <td width="50%" v-show="registration.eventData.data.occupation_area">
                        <strong>Qualificação/Área de Conhecimento:</strong>
                        {{registration.eventData.data.occupation_area}}
                    </td>
                </tr>
                <tr>
                    <td valign="top" width="50%" v-if="modalities.length > 0">
                        <strong>Modalidades:</strong><br>
                        <ul class="modalities-list">
                            <li v-for="item in modalities">
                                {{item.event.title}} / <strong>{{item.modality.name}}</strong>
                                <span v-if="item.modality.key === 'avaliador'"> / {{showEvaluations(item.id)}}</span>
                            </li>
                        </ul>
                    </td>
                    <td valign="top" width="50%" v-if="registration.eventData.data.knowledge_areas.length > 0">
                        <strong>Áreas de conhecimento:</strong><br>
                        <ul class="modalities-list">
                            <li v-for="item in registration.eventData.data.knowledge_areas">
                                {{item.full_name}}
                            </li>
                        </ul>
                    </td>
                </tr>
                </tbody>
            </table>
            <el-alert title="Minicursos disponíveis"
                      class="submission-tips"
                      type="warning"
                      v-if="registration.eventData.data.minicurso"
                      :closable="false">
                <ul>
                    <li>Após confirmar a inscrição no Congrega você terá acesso a lista de minicursos</li>
                </ul>
            </el-alert>
            <div class="buttons-center buttons">
                <el-button type="success"
                           size="large"
                           @click="onSaveRegistration()"
                           class="btn-confirm-registration">
                    Confirmar Inscrição
                </el-button>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .modalities-list {
        margin: 5px 0 0 0;
        padding: 0;
        list-style: none;
        li {
            padding: 6px 15px;
            background-color: #f6f6f6;
            margin-bottom: 1px;
        }
    }
</style>
